import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';

export default function DateRangeFilter({ dateStart, dateEnd, onStartChange, onEndChange, onClear }) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline" size="sm"
        className={`border-input h-8 text-xs ${!dateStart && !dateEnd ? 'bg-brand-accent/10 text-brand-accent border-brand-accent/20' : 'text-muted-foreground'}`}
        onClick={onClear}
      >
        All
      </Button>
      <div className="flex items-center gap-1.5">
        <Calendar className="w-3.5 h-3.5 text-muted-foreground" />
        <input
          type="date" value={dateStart || ''}
          onChange={e => onStartChange(e.target.value)}
          className="bg-muted border border-input text-foreground text-xs rounded-md px-2 py-1.5 h-8 w-36"
        />
        <span className="text-muted-foreground text-xs">to</span>
        <input
          type="date" value={dateEnd || ''}
          onChange={e => onEndChange(e.target.value)}
          className="bg-muted border border-input text-foreground text-xs rounded-md px-2 py-1.5 h-8 w-36"
        />
      </div>
    </div>
  );
}
